import { getShadowRoot } from "../utils/store";
import { uuidv4 } from "../utils/index";
import { nextPrev } from "../utils/StepService";

class SelfieInstruction {
  constructor() {
    this.formId = null;
  }

  render = async () => {
 const shadowRoot = getShadowRoot();
  const modalBox = shadowRoot.querySelector("#identity-modal__box");
  this.formId = `selfieInstructionContent-${uuidv4()}`;
    // Inject Styles (only once)
    if (!shadowRoot.querySelector("#selfie-instruction-style")) {
      const style = document.createElement("style");
      style.id = "selfie-instruction-style";
      style.textContent = `
        .selfie-wrapper {
          justify-content: center;
          align-items: center;
          padding: 30px 20px;
          font-family: Arial, sans-serif;
        }

        .selfie-wrapper.active {
          display: flex;
        }

        .selfie-card {
          // background: #f4f4f4;    
          background: #03101b;
          border: 1px solid #1b354c;
          border-radius: 12px;
          padding: 35px 25px;
          text-align: center;
          max-width: 100%;
          width: 100%;
        }

        .selfie-icon {
          margin-bottom: 15px;
        }

        .face-circle {
          width: 90px;
          height: 90px;
          border: 3px solid #e5e7e9;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto;
        }

        .face-circle svg {
          width: 40px;
          height: 40px;
          fill: #e5e7e9;
        }

        .selfie-title {
          font-size: 20px;
          font-weight: 600;
          margin: 15px 0 25px;
          color: #e5e7e9;
        }

        .selfie-list {
          list-style: none;
          padding: 0;
          text-align: left;
          margin-bottom: 30px;
        }

        .selfie-list li {
          margin-bottom: 12px;
          font-size: 14px;
          display: flex;
          align-items: center;
          margin-left: 0;
          // color: black;
          color: #e5e7e9;
        }

        .selfie-list li.success::before {
  content: "✓";
  color: #22c55e;
  font-size: 16px;
  margin-right: 10px;
}

.selfie-list li.error::before {
  content: "✕";
  color: #ef4444;
  font-size: 16px;
  margin-right: 10px;
}
        .selfie-btn {
          width: 100%;
          background: linear-gradient(90deg, #4f7cff, #3461e8);
          border: none;
          color: white;
          padding: 14px;
          border-radius: 10px;
          font-weight: 600;
          cursor: pointer;
          font-size: 14px;
          transition: 0.3s ease;
        }

        .selfie-btn:hover {
          opacity: 0.9;
        }
      `;
      shadowRoot.appendChild(style);
    }

    modalBox.insertAdjacentHTML(
      "beforeend",
      `
      <form class="selfie-wrapper form-content active"
      id="${this.formId}"
      data-form-tab="0">
        <div class="selfie-card">

          <div class="selfie-icon">
            <div class="face-circle">
              <!-- Simple Face SVG -->
              <svg viewBox="0 0 24 24">
                <circle cx="12" cy="8" r="4"></circle>
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6"></path>
              </svg>
            </div>
          </div>

          <h2 class="selfie-title">
            Take a clear selfie <br/> for verification
          </h2>

          <ul class="selfie-list">
            <li class="success">Face centered in frame</li>
            <li class="success">Good lighting, no shadows</li>
            <li class="success">No glasses, mask, or hat</li>
            <li class="error">Blurry or dark photo</li>
            <li class="error">Face cut off or tilted</li>
            <li class="error">Covered face (sunglasses, mask)</li>
          </ul>

          <button type="button"
                  id="btn-start-selfie"
                  class="selfie-btn">
            Continue to Selfie Capture
          </button>

        </div>

      </form>
      `
    );

    this.bindEvents();
  };

bindEvents() {
  const shadowRoot = getShadowRoot();
  const container = shadowRoot.querySelector(`#${this.formId}`);
  
  if (!container) {
    console.error("❌ SelfieInstruction form container not found", this.formId);
    return;
  }

  const startBtn = container.querySelector("#btn-start-selfie");

  if (!startBtn) {
    console.error("❌ Start button not found in container");
    return;
  }

  console.log("✅ Binding click event to start button");

  // Use addEventListener for better event handling
  startBtn.addEventListener("click", async (e) => {
    e.preventDefault();
    e.stopPropagation();

    console.log("🎯 Start button clicked - moving to selfieVerification");

    try {
      await nextPrev(1);
      const shadowRoot = getShadowRoot();
const oldForm = shadowRoot.querySelector(`#${this.formId}`);
if (oldForm) oldForm.remove();
      console.log("✅ Successfully progressed to selfieVerification");
    } catch (error) {
      console.error("❌ Error navigating to selfieVerification:", error);
    }
  });
}
  
}

export default SelfieInstruction;
